module.exports = __webpack_public_path__ + "static/oculus-e36b680b8032ef921067d9c759a74d6a.jpg";